import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/contact-us";

export default class ContactUs extends Page {
  title = "contact-us";

  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `${this.ucfirst("Contact Us")} | ${this.ucfirst("window-title")}`
    );
  }
}
